import { HAKLAI_EXPENSE_POLICY_TEXTS } from "../haklaiExpenseTexts";

export const HAKLAI_EXPENSE_DEPRECIATION_POLICY = {
  NONE: "none",
  OPTIONAL_MANUAL: "optionalManual"
};

export const HAKLAI_EXPENSE_DEPRECIATION_DECISION = {
  UNDECIDED: "",
  NONE: "none",
  FORM_11: "form11",
  RESIDENTIAL_AUTO: "residentialAuto"
};

export const HAKLAI_MAX_EXPENSE_DEPRECIATION_SELECTIONS_PER_PART = 4;

export const HAKLAI_DEPRECIATION_SELECTION_LIMIT_TITLE =
  HAKLAI_EXPENSE_POLICY_TEXTS.depreciationSelectionLimitTitle;
export const HAKLAI_DEPRECIATION_SELECTION_LIMIT_TEXT =
  HAKLAI_EXPENSE_POLICY_TEXTS.depreciationSelectionLimitText;

const isPlainObject = (value) => (
  value && typeof value === "object" && !Array.isArray(value)
);

export const getHaklaiExpenseTypeDepreciationPolicy = (expenseType = "") => (
  String(expenseType || "").trim()
    ? HAKLAI_EXPENSE_DEPRECIATION_POLICY.OPTIONAL_MANUAL
    : HAKLAI_EXPENSE_DEPRECIATION_POLICY.NONE
);

export const isHaklaiExpenseDepreciationPolicyRelevant = (policy = "") => (
  policy !== HAKLAI_EXPENSE_DEPRECIATION_POLICY.NONE
);

export const getHaklaiExpenseDepreciationDecision = (depreciation = {}) => {
  if (!isPlainObject(depreciation)) return HAKLAI_EXPENSE_DEPRECIATION_DECISION.UNDECIDED;
  if (
    depreciation.decision === HAKLAI_EXPENSE_DEPRECIATION_DECISION.NONE
    || depreciation.decision === HAKLAI_EXPENSE_DEPRECIATION_DECISION.FORM_11
    || depreciation.decision === HAKLAI_EXPENSE_DEPRECIATION_DECISION.RESIDENTIAL_AUTO
  ) {
    return depreciation.decision;
  }
  return Object.prototype.hasOwnProperty.call(depreciation, "depreciationResult")
    ? HAKLAI_EXPENSE_DEPRECIATION_DECISION.FORM_11
    : HAKLAI_EXPENSE_DEPRECIATION_DECISION.UNDECIDED;
};

export const hasHaklaiExpenseDepreciationDecision = (depreciation = {}) => {
  const decision = getHaklaiExpenseDepreciationDecision(depreciation);
  return Boolean(decision && decision !== HAKLAI_EXPENSE_DEPRECIATION_DECISION.NONE);
};

export const isHaklaiExpenseDepreciationStateMeaningful = (depreciation = {}) => (
  isPlainObject(depreciation)
  && hasHaklaiExpenseDepreciationDecision(depreciation)
);

export const hasHaklaiExpenseManualDepreciationInput = (depreciation = {}) => (
  isPlainObject(depreciation)
  && Object.prototype.hasOwnProperty.call(depreciation, "depreciationResult")
);

export const hasHaklaiExpenseDepreciationDraftInput = (depreciation = {}) => {
  if (!isPlainObject(depreciation)) return false;
  const decision = getHaklaiExpenseDepreciationDecision(depreciation);
  if (decision === HAKLAI_EXPENSE_DEPRECIATION_DECISION.FORM_11) return true;
  if (decision === HAKLAI_EXPENSE_DEPRECIATION_DECISION.RESIDENTIAL_AUTO) return true;
  return (
    decision === HAKLAI_EXPENSE_DEPRECIATION_DECISION.NONE
    && hasHaklaiExpenseManualDepreciationInput(depreciation)
  );
};

const normalizeManualForm11ExpenseDepreciation = (
  depreciation = {},
  decision = HAKLAI_EXPENSE_DEPRECIATION_DECISION.FORM_11
) => {
  const normalized = { decision };
  const depreciationResult = Number(depreciation.depreciationResult);
  if (Number.isFinite(depreciationResult)) {
    normalized.depreciationResult = depreciationResult;
  }
  if (typeof depreciation.depCurrency === "string" && depreciation.depCurrency) {
    normalized.depCurrency = depreciation.depCurrency;
  }
  return normalized;
};

export const normalizeHaklaiExpenseDepreciationDecisionState = (depreciation = {}) => {
  if (!isPlainObject(depreciation)) return {};
  const decision = getHaklaiExpenseDepreciationDecision(depreciation);
  if (decision === HAKLAI_EXPENSE_DEPRECIATION_DECISION.FORM_11) {
    return normalizeManualForm11ExpenseDepreciation(depreciation);
  }
  if (
    decision === HAKLAI_EXPENSE_DEPRECIATION_DECISION.NONE
    && hasHaklaiExpenseManualDepreciationInput(depreciation)
  ) {
    return normalizeManualForm11ExpenseDepreciation(
      depreciation,
      HAKLAI_EXPENSE_DEPRECIATION_DECISION.NONE
    );
  }
  if (decision === HAKLAI_EXPENSE_DEPRECIATION_DECISION.RESIDENTIAL_AUTO) {
    return { decision };
  }
  return {};
};
